module.exports = __webpack_public_path__ + "media/application/images/colors/books_blue-ff35afee719c552fe59ed5d37ba0ae65.png";